import { Selection } from 'src/projects/types/Selection';

export class SelectionRepository {
    private selections: Selection[];

    public constructor(selections: Selection[]) {
        this.selections = selections;
    }

    public proposeName(prefix = 'Selection') {
        let candidate = this.selections.length + 1;
        let found = this.selections.find((s) => s.name === `${prefix} ${candidate}`);
        while (found !== undefined) {
            candidate += 1;
            const name = `${prefix} ${candidate}`;
            found = this.selections.find((s) => s.name === name);
        }
        return `${prefix} ${candidate}`;
    }

    public count(): number {
        return this.selections.length;
    }

    public list(limit: number, offset: number): Selection[] {
        return this.selections.slice(offset, offset + limit);
    }

    public remove(selection: Selection): Selection[] {
        this.selections = this.selections.filter((s) => s.name !== selection.name);
        return this.selections;
    }

    public add(selection: Selection): Selection[] {
        this.selections = [selection, ...this.selections];
        return this.selections;
    }

    public get(name: string): Selection | null {
        const item = this.selections.find((v) => v.name === name);
        return item || null;
    }

    public update(selection: Selection): boolean {
        const item = this.selections.findIndex((v) => v.name === selection.name);
        if (item > -1) {
            this.selections[item] = selection;
        } else {
            this.add(selection);
        }
        return true;
    }
}
